<div class="flex pt-2">

  <ng-container *ngIf="isLogin">
    <div>
      <a rel="nofollow" [href]="linkPanelMobile" target="_blank" class="flex flex-col pr-2 w-[65%]">
        <i class="avatar-user-icon w-12 aspect-square mr-3 ml-14 rounded-3xl"></i>
      </a>
    </div>
  </ng-container>

  <div class="w-full flex justify-end items-center">
    <span class="sr-only">ایرانی اکسپرت - IRani Expert</span>
    <a
      href="https://www.iraniexpert.com"
      target="_blank"
      rel="follow"
      class="inline-flex -mt-2">
      <img
        title="ایرانی اکسپرت - Irani Expert"
        src="assets/icon/logo.svg"
        class="mr-1 h-14 w-40 pt-2"
        alt="لوگو اختصاصی ایرانی اکسپرت"
        width="34"
        height="20"
        loading="lazy"
      />
    </a>

    <button
    type="button"
    class="ml-4 mr-8 menu-trigger"
    aria-label="باز کردن منوی سایت"
    (click)="openMenu()">
    <i class="icon-menu" aria-hidden="true"></i>
    </button>

  </div>
</div>

<div 
  class="overlay flex items-center justify-start pr-4 overflow-x-hidden" 
  *ngIf="isVisible || isFadingOut" 
  [class.fade-in]="isVisible && !isFadingOut" 
  [class.fade-out]="isFadingOut" 
  (animationend)="onAnimationEnd()">
  
  <div class="absolute flex left-0">
    <img
    src="../../../../assets/img/Screenshot.webp"
    class="w-48 md:w-[28rem] h-[38rem] cursor-pointer relative z-10 rounded-3xl img-menu"
    (click)="closeMenu()"
    width="192"
    height="608"
    loading="lazy"
    alt="اسکرین شات صفحه اصلی"/>
    <img
    src="../../../../assets/img/Screenshot.webp"
    class="w-48 md:w-[28rem] h-[38rem] rounded-3xl relative -z-10 opacity-70 img-menu-2"
    width="192"
    height="608"
    loading="lazy"
    alt="اسکریان شات صفحه اصلی"/>

    <div class="box-close" (click)="closeMenu()">
      <p class="text-xs text-white font-medium">بازگشت به سایت</p>
      <i class="close-white w-4 mr-3"></i>
    </div>
  </div>

  <ul class="flex flex-col items-start relative z-20">

    <div class="flex mb-4 -mr-4" *ngIf="isLogin">
      <a [href]="linkPanelMobile" target="_blank">
        <i class="avatar-user-icon w-12 aspect-square mr-3 ml-4 rounded-3xl"></i>
      </a>
      <div>
        <p class="text-white text-lg">{{ userNameMobile }}</p>
        <p class="text-white text-xs">جهت ورود به پنل کلیک کنید</p>
      </div>
    </div>

    <ng-container *ngFor="let item of menuItems.slice(0,7);let i = index">
      <li class="my-3 flex flex-col items-start" [class.active]="isActive(item.path!)">
  
        <div class="flex items-center">
          <ng-container *ngIf="item.activeRoute">
            <a rel="follow" target="_blank" [href]="item.path" class="flex items-center">
              <img class="w-6 ml-2" [src]="item.icon" alt="menu-icon" loading="lazy">
              <p class="text-white font-medium">{{item.name}}</p>
            </a>
          </ng-container>
          <ng-container *ngIf="!item.activeRoute">
            <div class="flex items-center">
              <img class="w-6 ml-2" [src]="item.icon" alt="menu-icon" loading="lazy">
              <p class="text-white font-medium">{{item.name}}</p>
            </div>
          </ng-container>
          <img class="w-6 mr-2 cursor-pointer" alt="dropdown" loading="lazy" (click)="showSubItem(i)" [src]="item.iconDropDown" alt="">
        </div>
        
        <ul *ngIf="dropdownInDOM[i]" class="dropdown-menu flex flex-col items-start mr-8 mb-2 mt-4" [class.fade-in]="dropdownStates[i]" [class.fade-out]="!dropdownStates[i]">
          <li *ngFor="let itemSub of item.sub" class="my-1" [class.active]="isActive(itemSub.path!)">
            <a rel="follow" target="_blank" class="text-white font-medium" [href]="itemSub.path">{{itemSub.name}}</a>
          </li>
        </ul>
  
      </li>
    </ng-container>

    <li class="justify-end p-2.5 pr-8 flex" *ngIf="!isLogin">
      <button
        aria-label="ورود و عضویت"
        type="button"
        name="login"
        (click)="openModal('login')"
        class="text-1.5xl header-sm-button font-medium rounded-3xl px-4 !bg-[#7683E2]">
        ورود | عضویت
      </button>
      </li>
      <li class="justify-end p-2.5 pr-8 flex flex-col" *ngIf="isLogin">
      <button
      aria-label="خروج از حساب"
      type="button"
      name="logout"
      (click)="logout()"
      class="text-1.5xl header-panel-button font-medium rounded-3xl pr-4 pl-2 mb-2 py-2 flex !bg-[#7683E2]">
        خروج از حساب
        <i class="icon-menu-log-out mr-1"></i>
      </button>
    </li>

  </ul>

</div>